import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getCoachBySlug } from '../utils/coaches';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/App.css';
import HeroImage from '../assets/images/HeroCoach.png';

function CoachLanding() {
  const { slug } = useParams();
  const [coach, setCoach] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      setError('No coach specified');
      return;
    }
    getCoachBySlug(slug)
      .then((c) => {
        setCoach(c);
        setError(!c ? 'Coach not found' : null);
      })
      .catch((err) => {
        console.error('[CoachLanding] Error:', err);
        setError('Could not load coach page');
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="home">
        <Header />
        <main style={{ padding: '80px 24px', textAlign: 'center', minHeight: '50vh' }}>
          <p>Loading...</p>
        </main>
        <Footer />
      </div>
    );
  }

  if (error || !coach) {
    return (
      <div className="home">
        <Header />
        <main style={{ padding: '80px 24px', textAlign: 'center', minHeight: '50vh' }}>
          <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: '48px', marginBottom: '24px' }}>
            Team Not Found
          </h2>
          <p style={{ marginBottom: '32px' }}>{error || 'This team page does not exist or has been removed.'}</p>
          <Link to="/coach" className="c-ripple primary-button">Learn More</Link>
        </main>
        <Footer />
      </div>
    );
  }

  const signupUrl = `/signup?coach=${coach.slug}`;

  return (
    <div className="home">
      <SEO
        title={`Join ${coach.name} | Begin Strength`}
        description={`Sign up for the Begin Strength program with ${coach.name}. Get started today.`}
        path={`/coach/${coach.slug}`}
      />
      <Header />
      <main>
        <div className="hero" style={{ backgroundImage: `url(${HeroImage})` }}>
          <div className="hero-overlay">
            <div className="hero-content">
              <h2 className="hero-header">
                Train with <span style={{ color: 'red' }}>{coach.name}</span>
              </h2>
              <div className="hero-paragraph">
                <p>Sign up for the Begin Strength Volleyball Program with {coach.name}.</p>
                <p>Get periodized strength training built for volleyball — vertical power, lateral explosion, and workouts that fit your schedule.</p>
              </div>
              <div className="hero-buttons">
                <Link to={signupUrl} className="c-ripple primary-button">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: '60px 24px', textAlign: 'center', maxWidth: '640px', margin: '0 auto' }}>
          <p style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            Already have an account? <Link to={`/signin?coach=${coach.slug}`} style={{ color: '#FF0000', textDecoration: 'underline' }}>Sign in</Link> to join this team.
          </p>
          <Link to="/coach" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'underline', fontSize: '14px' }}>
            Learn more about the program
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default CoachLanding;
